import type { ClientToolContext } from "../nest/clientTools"

export type BrowserOperation = "observe" | "control" | "user-action"
export type BrowserGrantDecision = "allow" | "prompt" | "deny"

type BrowserGrantContext = Pick<ClientToolContext, "mode" | "permissionMode">

export function browserGrantDecision(context: BrowserGrantContext, operation: BrowserOperation): BrowserGrantDecision {
    if (context.mode === "read-only" && operation !== "observe") return "deny"
    if (context.permissionMode === "ask" && operation === "control") return "prompt"
    return "allow"
}

export function browserStartRequiresConsent(permissionMode: ClientToolContext["permissionMode"]): boolean {
    return permissionMode !== "yolo"
}
